import { render, staticRenderFns } from "./NotAuditList.vue?vue&type=template&id=708a222b&scoped=true&"
import script from "./NotAuditList.vue?vue&type=script&lang=js&"
export * from "./NotAuditList.vue?vue&type=script&lang=js&"
import style0 from "./NotAuditList.vue?vue&type=style&index=0&id=708a222b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a222b",
  null
  
)

export default component.exports